import * as Yup from 'yup';
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';

// material
import { Alert, Box, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useAuth } from '../../../context/AuthContext';

// ----------------------------------------------------------------------

export default function ForgetPasswordForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required')
  });
  const emailRef = useRef();
  const { resetPassword } = useAuth();

  const formik = useFormik({
    initialValues: {
      email: '',
      remember: true
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      navigate('/dashboard', { replace: true });
    }
  });

  const { errors, touched, getFieldProps } = formik;

  async function handleFormSubmit(e) {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      await resetPassword(emailRef.current.value);
      setLoading(false);
      navigate('/login', { replace: true });
    } catch (error) {
      setLoading(false);
    }
  }
  return (
    <FormikProvider value={formik}>
      <Box m={2} pt={3}>
        {error && <Alert severity="error">{error}</Alert>}
      </Box>
      <Form autoComplete="off" noValidate onSubmit={(e) => handleFormSubmit(e)}>
        <Box m={4} pt={0}>
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            inputRef={emailRef}
            label="Email address"
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />
        </Box>
        <Box m={4} pt={0}>
          {emailRef.current?.value ? (
            <LoadingButton
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={loading}
            >
              Reset password
            </LoadingButton>
          ) : (
            <LoadingButton fullWidth size="large" type="submit" variant="contained" disabled>
              {' '}
              Reset password
            </LoadingButton>
          )}
        </Box>
      </Form>
    </FormikProvider>
  );
}
